import { buildMockPromise } from "../api/helpers";
import { ActorInfoApi, ActorSummaryListInputApi } from "../api/Users";

export const actorInfoList: ActorInfoApi[] = [
  {
    actor_uuid: "user1f-4408-44ec-9fa4-db4b17fdbf60",
    actorName: "user 1",
    email: "user1@domain.com",
    role_uuids: ["role2f1f-4408-44ec-9fa4-db4b17fdbf60"],
    company_uuids: ["comp2f1f-4408-44ec-9fa4-db4b17fdbf60"],
  },
  {
    actor_uuid: "user2f-4408-44ec-9fa4-db4b17fdbf60",
    actorName: "user 2",
    email: "user2@domain.com",
    role_uuids: ["role3f1f-4408-44ec-9fa4-db4b17fdbf60"],
    company_uuids: [],
    is_active: true,
  },
  {
    actor_uuid: "user3f-4408-44ec-9fa4-db4b17fdbf60",
    actorName: "user 3",
    email: "user3@domain.com",
    role_uuids: [
      "role1f1f-4408-44ec-9fa4-db4b17fdbf60",
      "role3f1f-4408-44ec-9fa4-db4b17fdbf60",
    ],
    company_uuids: [
      "comp1f1f-4408-44ec-9fa4-db4b17fdbf60",
      "comp2f1f-4408-44ec-9fa4-db4b17fdbf60",
      "comp3f1f-4408-44ec-9fa4-db4b17fdbf60",
    ],
    all_companies: true,
  },
];

function buildActorInfoApiListMock(numItems: number): ActorInfoApi[] {
  const list: ActorInfoApi[] = [];
  for (let i = 1; i <= numItems; i++) {
    if (i >= 1 && i < 4) {
      list.push(actorInfoList[i - 1]);
    } else {
      list.push({
        actor_uuid: `use${i}f-4408-44ec-9fa4-db4b17fdbf60`,
        actorName: `User ${i}`,
        email: `user${i}@domain.com`,
        is_active: i % 3 ? true : false,
        role_uuids: [
          "role1f1f-4408-44ec-9fa4-db4b17fdbf60",
          "role2f1f-4408-44ec-9fa4-db4b17fdbf60",
        ],
        company_uuids: ["comp2f1f-4408-44ec-9fa4-db4b17fdbf60"],
      });
    }
  }
  return list;
}

export function getActorSummaryMock() {
  return [
    {
      actor_uuid: "61259ac9-55a6-4bff-a131-88a99c58f66f",
      first_name: "Sajud",
      last_name: "Hamza",
      email: "sajud@fama.io",
      modified_by: "61259ac9-55a6-4bff-a131-88a99c58f66f",
      last_action_at: null,
      last_action: "",
      tasks: {
        workflow: {
          WorkflowStepConfigs: ["qwerty"],
        },
      },
    },
    {
      actor_uuid: "4bc97f20-7f2a-4809-83ff-45c9ce4441a1",
      first_name: "string",
      last_name: "string",
      email: "fama_admin@fama.io",
      modified_by: "4bc97f20-7f2a-4809-83ff-45c9ce4441a1",
      last_action_at: null,
      last_action: "",
      tasks: {
        workflow: {
          WorkflowStepConfigs: ["asdf", "qwerty"],
        },
        blueprint: {
          Blueprints: [
            "5b8a4cdf-91e0-43c0-bc14-d41a2b9cc9f0",
            "ca123196-1e39-421f-b96a-912b77d8051f",
          ],
        },
      },
    },
    {
      actor_uuid: "c3c3fe6f-293f-43b8-93a9-ea4917cc8c34",
      first_name: "accountmanager@fama.io",
      last_name: "",
      email: "accountmanager@fama.io",
      modified_by: "c3c3fe6f-293f-43b8-93a9-ea4917cc8c34",
      last_action_at: null,
      last_action: "",
      tasks: {},
    },
    {
      actor_uuid: "1b0cb27c-edc5-42a7-a31e-56429455e0dc",
      first_name: "grant_deleteme20231212@fama.io",
      last_name: "",
      email: "grant_deleteme20231212@fama.io",
      modified_by: "1b0cb27c-edc5-42a7-a31e-56429455e0dc",
      last_action_at: null,
      last_action: "",
      tasks: {},
    },
    {
      actor_uuid: "54e68b7b-2842-4334-ab95-0a8274303fa4",
      first_name: "philippeBulkCreate1@gmail.com",
      last_name: "",
      email: "philippeBulkCreate1@gmail.com",
      modified_by: "54e68b7b-2842-4334-ab95-0a8274303fa4",
      last_action_at: null,
      last_action: "",
      tasks: {},
    },
    {
      actor_uuid: "158ede52-b751-4e14-b4e6-0f0c37dc9f28",
      first_name: "philippeBulkCreate3@gmail.com",
      last_name: "",
      email: "philippeBulkCreate3@gmail.com",
      modified_by: "158ede52-b751-4e14-b4e6-0f0c37dc9f28",
      last_action_at: null,
      last_action: "",
      tasks: {},
    },
    {
      actor_uuid: "3e53f0ec-f6bc-4092-a22d-0fff36c77c82",
      first_name: "philippeBulkCreate2@gmail.com",
      last_name: "",
      email: "philippeBulkCreate2@gmail.com",
      modified_by: "3e53f0ec-f6bc-4092-a22d-0fff36c77c82",
      last_action_at: null,
      last_action: "",
      tasks: {},
    },
  ];
}

export async function getActorInfoMock(
  user_uuid: string
): Promise<ActorInfoApi> {
  const actorInfo = actorInfoList.find((user) => user.actor_uuid === user_uuid);
  if (!actorInfo) {
    throw new TypeError("Unexpected Exception");
  }
  return await buildMockPromise<ActorInfoApi>(actorInfo);
}

export async function getActorInfoListMock(
  input: ActorSummaryListInputApi
): Promise<ActorInfoApi[]> {
  const numberOfMockedItems = 100;
  let list = buildActorInfoApiListMock(numberOfMockedItems);
  const currentIndex = (input.pageNumber - 1) * input.pageSize;
  list = list.slice(currentIndex, currentIndex + input.pageSize);
  let result: ActorInfoApi[] = list;

  if (input.filter) {
    const filter = input.filter || "";
    result = list.filter((actor) => {
      return (
        actor.email.indexOf(filter.trim()) >= 0 ||
        actor.actorName.indexOf(filter.trim()) >= 0
      );
    });
  }
  return await buildMockPromise<ActorInfoApi[]>(result);
}

export async function getActorTasksMock(): Promise<any> {
  return [
    {
      external_id: "c5ac54b3-70ed-4044-b487-6693dab5aec5",
      is_deleted: false,
      domain: "workflow",
      model: "WorkflowStepConfigs",
      key: "asdf",
      display: "ProfileConfirm",
      order: 2,
    },
    {
      external_id: "a806460c-93c1-48c0-9fba-b122b9414e81",
      is_deleted: false,
      domain: "workflow",
      model: "WorkflowStepConfigs",
      key: "qwerty",
      display: "Post Scrape",
      order: 1,
    },
    {
      external_id: "a806460c-93c1-48c0-9fba-b122b9414e82",
      is_deleted: false,
      domain: "workflow",
      model: "WorkflowStepConfigs",
      key: "zxcv",
      display: "Web Content Review",
      order: 2,
    },
    {
      external_id: "92d075b8-6f89-4be2-825f-3b3a5ff28977",
      is_deleted: false,
      domain: "blueprint",
      model: "Blueprints",
      key: "5b8a4cdf-91e0-43c0-bc14-d41a2b9cc9f0",
      display: "Express Template",
      order: 1,
    },
    {
      external_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      is_deleted: false,
      domain: "blueprint",
      model: "Blueprints",
      key: "ca123196-1e39-421f-b96a-912b77d8051f",
      display: "Blueprint Blue",
      order: 2,
    },
  ];
}
